import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar'
import { Subject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { FormService } from '../../dhl-form/services/form.service';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
//import '../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,920,24,24))'


@Component({
    selector: 'app-generic-modal-v2',
    templateUrl: './generic-modal-v2.component.html',
    styleUrls: ['./generic-modal-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericModalV2Component implements OnInit {

  public subject: Subject<boolean>;
  showModalForm: boolean = false;
  enum = ModalConfigData;
  parentfrmGroup: any;

  constructor(private _snackBar: MatSnackBar, private formService: FormService, private appService: AppService, public dialogRef: MatDialogRef<GenericModalV2Component>, @Inject(MAT_DIALOG_DATA) public modalData: any) {
    // console.log(modalData);
  }

  getColsClass(cols: number[]) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass;
  }

  config: any;
  formGroup: any;
  position: number;
  editMode: boolean = false;
  data: any;

  ngOnInit() {
    if (this.modalData.modalForm) {
      this.config = this.modalData.modalForm.template;
      this.formGroup = this.modalData.modalForm.frmGroup;
      this.position = this.modalData.modalForm.position;
      this.editMode = this.modalData.modalForm.editMode;
      this.data = this.modalData.data;
      this.parentfrmGroup = this.modalData?.modalForm?.parentfrmGroup ?? null;
    }
  }

  getFormTableControls() {
    return this.formGroup.controls;
  }

  actionFunction(event) {
    if(event){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (this.subject) {
      this.subject.next(true);
      this.subject.complete();
    }
    this.dialogRef.close(true);
  }

  closeModal(event) {
    if(event){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (this.subject) {
      this.subject.next(false);
      this.subject.complete();
    }
    this.dialogRef.close(false);
  }

 
  durationInSeconds = 20;

  /**
   * 
   * @param event : string {Submit | Cancel }
   * @param formGroup : FormGroup
   * @param modalData : Object<any>{}
   * 
   * 1. OnSubmit of common form it will send data back to where modal created
   * 2. modalData.name should be unique to identify If more than one subscriber available in same screen 
   */
  onSubmitEvent(event, formGroup, modalData) {
    if (modalData.action == false) {
      this.dialogRef.close(true);
      return;
    }
    let data = {
      event: event,
      name: modalData.name,
      formValue: this.formGroup.getRawValue(),
      configData:  modalData.modalForm.template,
      data: this.data,
      parentfrmGroup: this.parentfrmGroup
      }
    this.appService._modalCommonFormSubjecct.next(data)
    if(modalData.config?.keepOpenAfterSubmit){
      return;
    }
    this.dialogRef.close(true);
  }

  onCloseModalEvent(event, formGroup, modalData, e) {
    if(e){
      e.preventDefault();
      e.stopImmediatePropagation();
    }
    if (modalData.action == false) {
      this.dialogRef.close(true);
      return;
    }
    let data = {
      event: event,
      name: modalData.name,
      formValue: this.formGroup.getRawValue()
    }
    this.appService._modalCommonFormSubjecct.next(data);
    if(data.event == 'submit' && modalData.config?.keepOpenAfterSubmit){
      return;
    }
    this.dialogRef.close(true);
  }

}
